// src/api/axiosInstance.ts
import axios from 'axios';

let sessionTimeoutId: NodeJS.Timeout | null = null;
const SessionTimeOutHandler = 15 * 60 * 1000; // 5 minutes


const handleLogout = (navigate: any) => {
  // Clear data
  localStorage.clear();
  // Redirect to login page
  navigate('/');
};


const resetSessionTimeout = (navigate: any) => {
  if (sessionTimeoutId) {
    clearTimeout(sessionTimeoutId);
  }
  
  sessionTimeoutId = setTimeout(() => {
    // Only proceed with logout if user is still logged in
    if (localStorage.getItem('authToken')) {
      handleLogout(navigate);
    }
  }, SessionTimeOutHandler);
};

export const setupInterceptors = (navigate: any) => {
    axios.interceptors.response.use(
    (response) => response,
    (error) => {
        console.log("errrrrrrrrrrrr", error)
      if (error.response && error.response.status === 401) {
        console.log("errrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr", error)
        navigate('/'); // Redirect to login page
      }
      return Promise.reject(error);
    }
  );
  
  if (localStorage.getItem('authToken')) {
    resetSessionTimeout(navigate);
  }
  
  // Setup activity tracking
  const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];
  
  const activityHandler = () => {
    // Reset timeout on user activity if logged in
    if (localStorage.getItem('authToken')) {
      resetSessionTimeout(navigate);
    }
  };
  
  // Add event listeners
  events.forEach(event => {
    window.addEventListener(event, activityHandler);
  });
  
  // Return cleanup function
  return () => {
    events.forEach(event => {
      window.removeEventListener(event, activityHandler);
    });
    
    if (sessionTimeoutId) {
      clearTimeout(sessionTimeoutId);
    }
  };
};